module.exports = __webpack_public_path__ + "assets/851aa40d1cefaf498b31dbccd02fe8d9.mp3";